<template>
  <v-tooltip top>
    <template #activator="{ on }">
      <v-icon class="info-tooltip" v-on="on" color="icon">{{ icon }}</v-icon>
    </template>
    <p class="info-tooltip__content">{{ info }}</p>
  </v-tooltip>
</template>

<script>
  export default {
    name: "InfoTooltip",
    props: {
      info: {
        type: String,
        default: "",
      },
      icon: {
        type: String,
        default: "mdi-information",
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../@core/preset/preset/typography/index.scss";
  @import "../../@core/preset/preset/functions.scss";

  .info-tooltip {
    margin-left: 4px;
    &.v-icon {
      font-size: 18px;
    }
  }
</style>
